import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./style/index.css";
import { Main } from "./main.js";

const rootDomNode = document.getElementById("root");
const root = createRoot(rootDomNode);
root.render(
    <StrictMode>
        <Main />
    </StrictMode>
);
